/**
 * Copy the printed proposal carries that is not in STANDARD_COPY
 * (src/lib/proposalLooks.js, shared with the public page). Same voice: plain,
 * first person from Efren, no em dashes. None of it states a price.
 */

/** The five stages. Weeks are worked out from the proposal's own timeline. */
export const APPROACH = [
  ['Discovery', 'We talk to you, your team and your customers, and study who you compete with. We find the words that already work.', 'a half-day kickoff and one interview'],
  ['Strategy', 'Who you serve, why you win and how to say it, on one page you can read in two minutes.', 'a 60-minute readout'],
  ['Design', 'The work itself, shown on real things: your site, your documents, your space.', 'a 90-minute presentation'],
  ['Revisions', 'Two focused rounds, guided by a short feedback form so nothing gets lost.', 'two feedback rounds, 5 days each'],
  ['Delivery', 'Every file, a guide, and a handover session so your team uses it well from day one.', 'a 60-minute handover'],
]

/** Where each stage starts and ends, as a share of the whole timeline. */
export const APPROACH_SHARES = [0, 0.23, 0.31, 0.69, 0.85, 1]

export const STAY_IN_TOUCH = [
  ['The portal', 'Files, approvals and invoices. Your single source of truth.'],
  ['Email', 'Quick questions, answered within one business day.'],
  ['Calls', 'Presentations and workshops, booked a week ahead.'],
]

export const PRICE_COVERS = [
  ['Every deliverable', 'Everything on the scope pages, with two revision rounds each.'],
  ['Your time with me', 'Workshops, presentations and weekly updates.'],
  ['A locked price', 'The price holds for 30 days and does not change once you sign.'],
]

export const ON_THIS_PROJECT = [
  'Leads strategy and every workshop',
  'Sets the creative direction',
  'Presents each stage for approval',
  'Is your one point of contact',
]

export const OPTIONS_INCLUDE = [
  'Your own project portal',
  'Two revision rounds per deliverable',
  'Weekly updates from Efren',
  'Full ownership of the final work',
]

export const GLANCE_NEXT = 'Accept online and pay the first payment. We book kickoff within 3 business days.'

/*
 * The closing panels at the foot of each page (the soft panel at 822px in
 * every Figma frame). Generic enough for any service: nothing here names a
 * file format, an industry or a price.
 */
export const FIRST_TWO_WEEKS = [
  ['Day 1', 'Kickoff is booked within 3 business days of your yes.'],
  ['Week 1', 'Interviews with your team, and with the people you serve.'],
  ['Week 2', 'The first findings, shared in your portal.'],
]

export const WHERE_THINGS_STAND = [
  ['A Friday update', 'What was done, what is next, what we need from you.'],
  ['Approval at every stage', 'Nothing moves on without your written yes.'],
  ['One portal', 'Files, feedback, approvals and invoices in one place.'],
]

export const HOW_DELIVERED = [
  ['Files you own', 'Every final file, organised, named and yours to keep.'],
  ['Guides you can use', 'Clear guidance your team and vendors can follow.'],
  ['A proper handover', 'A walkthrough session, recorded for new hires.'],
]

export const CHANGE_THE_DATES = [
  ['Faster feedback', 'Answers in 2 to 3 days can bring launch forward.'],
  ['Slower reviews', 'Reviews over 10 business days pause the project.'],
  ['Holidays', 'We plan around them at kickoff, not after.'],
]

export const SAME_TERMS = [
  ['Fixed price', 'No hourly meter on anything in scope.'],
  ['Room to grow', 'Start smaller and add services later.'],
]

/** The line beside the letter, in Efren's voice. */
export const LETTER_PULL = 'The work is finished when the people you serve can say it back to you.'
